import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, FileText, Lock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-100 border-t border-slate-200 py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-4">
          {/* Logo and Company */}
          <div className="flex items-center space-x-2">
            <Shield className="h-5 w-5 text-slate-500" />
            <span className="font-heading font-semibold text-sm text-slate-700">AIVORA Comply360</span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link to="/terms" className="flex items-center gap-1.5 text-slate-500 hover:text-slate-700 transition-colors">
              <FileText className="h-3.5 w-3.5" />
              Terms of Service
            </Link>
            <Link to="/privacy" className="flex items-center gap-1.5 text-slate-500 hover:text-slate-700 transition-colors">
              <Lock className="h-3.5 w-3.5" />
              Privacy Policy
            </Link>
          </div>

          {/* Contact Email */}
          <div className="flex items-center gap-2">
            <a 
              href="mailto:support@aivora-techlabs.com" 
              className="flex items-center gap-1.5 text-sm text-blue-600 hover:text-blue-700 transition-colors"
            >
              <Mail className="h-4 w-4" />
              support@aivora-techlabs.com
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-200 pt-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2 text-center md:text-left">
            <p className="text-slate-500 text-xs">
              Designed and owned by AIVORA Techlabs Global Pvt Ltd
            </p>
            <p className="text-slate-400 text-xs">
              © {new Date().getFullYear()} All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
